import Vue from 'vue';
import EventBus from '@/event-bus';

/**
 * Generates a mixin that syncs a components data property with a prop.
 */
export function apiMixin(module) {
  return Vue.extend({
    data() {
      return {
        module: module
      }
    },
    methods: {
      /**
       *
       * @param {'busy'|'loader'} loaderType
       * @param {boolean} showSucess
       * @param {string} toastr
       * @param {() => Promise<any>} apiCall
       */
      async callApi(loaderType, isProposal, toastr, apiCall) {
        let result = null;
        try {
          if (loaderType == 'busy') {
            this.busy = true;
          } else {
            EventBus.$emit('showBlockUI', 'Please wait...');
          }
          result = await apiCall();
          if (isProposal) {
            this.$toastr.s('Proposal successfully submitted. Please wait for voting to complete', 'Success');
          }else{
            this.$toastr.s(toastr, 'Success');
          }
        } catch (e) {
          this.$showError(e);
        } finally {
          if (loaderType == 'busy') {
            this.busy = false;
          } else {
            EventBus.$emit('hideBlockUI');
          }
        }
        return result;
      }
    }
  });
}
